<div class="delete-warning">
  <div class="popup-top-line"></div>
  <div class="delete-warning-header">
    <div class="title">{{ this.details.title | labelsProvider }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="delete-warning-body">
    <div class="delete-warning-body-text">
      <img src="assets/images/common/warning.svg" />
      <div class="constant-text" *ngIf="!this.details.body">
        {{ 'common.areYouSureMessage' | labelsProvider }}
      </div>
      <div class="constant-text" *ngIf="this.details.body">
        {{ this.details.body | labelsProvider }}
      </div>
    </div>
    <div class="delete-warning-body-text">
      <div class="warning-text">{{ stringToPresent }}</div>
    </div>
  </div>
  <div class="delete-warning-banner" *ngIf="details.warningBanner">
    <span class="banner-icon">⚠</span>
    {{ details.warningBanner }}
  </div>
  <div class="delete-warning-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button class="confirm" (click)="confirmAction()" cdkFocusInitial>
      <span *ngIf="!waitingForResponse">{{ 'common.ok' | labelsProvider }}</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
